import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import {
  checkInvAccess,
  resetSortingAndFilters,
  successMessage,
  validateVanningDates,
  warningMessage,
} from 'src/app/constants';
import { logErrors } from 'src/app/shared/logger';
import { MatDialogConfig } from '@angular/material/dialog';
import { ColDef, IDetailCellRendererParams } from 'ag-grid-community';
import { CustomTooltipComponent } from 'src/app/core/custom-tooltip/custom-tooltip.component';
import { ExcelService } from 'src/app/services/excel.service';
import { GriddataService } from 'src/app/services/griddata.service';
import { GridRefreshComponent } from 'src/app/core/grid/grid-refresh/grid-refresh.component';
import { FluctuationAllowanceService } from 'src/app/services/fluctuation-allowance/fluctuation-allowance.service';
import { OSPStateService } from 'src/app/services/osp-state.service';
import { DeleteBreaksComponent } from 'src/app/configuration-shifts/breaks-detailview/delete-breaks/delete-breaks.component';
import { DeleteBtnCellRender } from 'src/app/configuration-shifts/breaks-detailview/review-changes/review-container.component/delete-btn-cell-render';
import { LookupService } from 'src/app/services/lookup/lookup.service';
import { PartsInventoryService } from 'src/app/services/parts-inventory/parts-inventory.service';
import { Location } from '@angular/common';
import { PartsActionsComponent } from 'src/app/configuration-parts/parts-actions/parts-actions.component';
import { EditPartsGroupDialogComponent } from './edit-parts-group/edit-parts-group-dialog.component';
import { AddPartsGroupDialogComponent } from './add-parts-group/add-parts-group-dialog.component';
import { PartstCountService } from 'src/app/services/parts-count/partsCount.service';
import { AgGridAngular } from 'ag-grid-angular';
import { HeaderCheckboxComponent } from 'src/app/core/grid/header-checkbox/header-checkbox.component';
import { RowCheckboxComponent } from 'src/app/core/grid/row-checkbox/row-checkbox.component';
import { ActivatedRoute, Router } from '@angular/router';
import { runInThisContext } from 'vm';
import { RowCheckboxPartsComponent } from './row-checkbox-parts.component';
import { HeaderCheckboxGroupComponent } from './add-parts-group/header-checkbox-group.component';
import { DefaultService } from '../../services/default.service';

@Component({
  selector: 'app-parts-group',
  templateUrl: './parts-group.component.html',
  styleUrls: ['./parts-group.component.scss']
})
export class PartsGroupComponent implements OnInit, OnDestroy {
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  selectedDockSubject = new BehaviorSubject<any>(null);
  count = 0;
  @ViewChild('osPartsGrid') osPartsGrid;
  @ViewChild('grid1') grid1: any;
  @ViewChild('grid2') grid2: any;
  @ViewChild('grid3') grid3: any;
  columnDefsMaster;
  columnDefsMaster1;
  columnDefsMaster2;
  rowData = [];
  displayRowData: any[] = []
  displayRowData1: any[] = []
  rowdata: any = [];

  rowSelection;
  user: string;
  userRole: any;
  warningMessage = '';
  offset: number = 0;
  dataCount: number = 0;
  modalComponent = 'modal-component';
  gridOptions;
  paginationPageSize;
  paginationPageSize1 ;
  paginationPageSize2 ;
  paginationNumberFormatter;
  pagination = 'true';
  context: any;
  editType;
  suppressClickEdit = true;
  tooltipShowDelay = 0;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  headerCheckboxChecked: boolean = false; // Grid 1
  headerCheckboxChecked1: boolean = false; // Grid 3
  partDesc = 'Part Description';

  editEnabled = false;
  freezeStatus = false;
  filter = false;
  showToggleAll = false;
  showClear = true;
  disablePartNumber: boolean;
  disableKanban: boolean;
  isManualSearch: boolean = false;
  // Dropdowns
  selectedKanban: any = [];
  selectedPartNo: any = [];
  selectedDock: any = [];
  selectedSpecialist: any = [];
  selectedpolicyName: any = [];
  effectiveFrom: any;
  effectiveTo: any;
  adjustSubscription$: Subscription;

  // Dropdown Options
  kanbanList: any = [];
  partNoList: any = [];
  partNoListAdd: any = [];
  dockList: any = [];
  dockListTo: any = [];
  dockListForpopup: any = [];
  dockListCopy: any = [];
  previousDock: string = '';  // Track previous dock selection
  // dockListAddGroup: any = [];
  specialistList: any = [];
  policyNameList: any = [];
  qpcforParts: any = [];
  rowCount = 0;
  count1 = 0;
  isEditMode = false;
  successMessage = '';

  kanbanSelected = 1;

  easternDate: any;
  defaultPageSize: any = 100000;
  itContact: any;

  partNumberList: any = [];
  kanbanNumberList: any = [];
  getAddressList : any = [];
  selectedGetAddress: any = [];
  selectedGroupId: any;
  access;
  accessEdit = false;
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly OspService: PartstCountService,
    private readonly OspService1: PartsInventoryService,
    private readonly excelService: ExcelService,
    private readonly gridDataService: GriddataService,
    public dialog: MatDialog,
    private readonly stateService: OSPStateService,
    private readonly flalService: FluctuationAllowanceService,
    private readonly lookupService: LookupService,
    private location: Location,
    private readonly partsCountService: PartstCountService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
    // this.defaultColDef = {
    //   resizable: true,
    //   filter: true,
    //   sortable: true,
    //   floatingFilter: true,
    // };
    // this.icons = {
    //   sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    // };
  }
  numberComparator(number1, number2) {
    return number1 - number2;
  }
  
  dateComparator(date1, date2) {
    function monthToNum(date) {
      if (date === undefined || date === null) {
        return null;
      }

      const newDate: Date = new Date(date);

      const yearNumber = newDate.getFullYear();
      const monthNumber = newDate.getMonth();
      const dayNumber = newDate.getDate();
      const hoursNumber = newDate.getHours();
      const minutesNumber = newDate.getMinutes();

      const result =
        yearNumber * 10000 +
        monthNumber * 100 +
        dayNumber +
        hoursNumber * 60 +
        minutesNumber * 10;
      return result;
    }

    // To be used inside filter params when using date filter

    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }
  gridOptions1 = {};
  gridOptions2 = {};
  gridOptions3 = {};
 
  onPageSizeChanged() {
    if (this.grid1?.api) {
      this.gridOptions?.api?.paginationSetPageSize(Number(this.paginationPageSize1));
    } else if (this.grid2?.api) {
      this.gridOptions?.api?.paginationSetPageSize(Number(this.paginationPageSize));
    } else if (this.grid3?.api) {
      this.gridOptions?.api?.paginationSetPageSize(Number(this.paginationPageSize2));
    }
  }
  
  setPageSizeToAll(clearData = false) {
    if (clearData) {
      this.paginationPageSize1 = 0;
      this.paginationPageSize = 0;
      this.paginationPageSize2 = 0;
      //this.rowData = [];
      this.displayRowData = [];
      this.displayRowData1 = [];
    } else {
      if (this.displayRowData?.length) {
        this.paginationPageSize1 = this.displayRowData.length;
      }
  
      if (this.rowData?.length) {
        this.paginationPageSize = this.rowData.length;
      }
  
      if (this.displayRowData1?.length) {
        this.paginationPageSize2 = this.displayRowData1.length;
      }
    }
  
    this.onPageSizeChanged();
    this.onPageSizeChanged();
    this.onPageSizeChanged();
  }

  ngOnDestroy(): void {
    this.adjustSubscription$.unsubscribe();
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.selectedDock && changes.selectedDock.currentValue !== changes.selectedDock.previousValue) {
  //     this.onSearch(0);  // Trigger the search method when selectedDock changes
  //   }
  // }

  public columnDefs: ColDef[]
  public columnDefs1: ColDef[]
  public columnDefs2: ColDef[]

  public defaultColDef;
  public groupDefaultExpanded = 1;
  public detailCellRendererParams
  

  ngOnInit(): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;
    // this.route.queryParams.subscribe(params => {
    //   const selectedDockParam = params['selectedDock'];

    //   if (selectedDockParam) {
    //     const selectedDockArray = JSON.parse(decodeURIComponent(selectedDockParam));
    //     const matchedDock = this.dockList.find(d => d.dock === selectedDockArray[0]);

    //     if (matchedDock) {
    //       this.selectedDock = matchedDock;
    //       console.log('Dock selected from query param:', this.selectedDock);
    //       this.selectedDockSubject.next(this.selectedDock); // Update BehaviorSubject
    //       this.onSearch(0); // Trigger search with the selected dock
    //     }
    //   }
    // });

    // Subscribe to selectedDock changes (from both query params and manual change)
    // this.selectedDockSubject.subscribe(dock => {
    //   if (dock) {
    //     console.log('Selected dock changed:', dock);
    //     this.onSearch(0); // Trigger search whenever the dock changes
    //   }
    // });
    //first grid
    this.columnDefsMaster1 = [
      
      {
        headerName: 'Action',
        // cellRendererFramework: PartsActionsComponent,
        // floatingFilterComponentFramework: GridRefreshComponent,
        field: 'actions',
        width: 80,
        sortable: false,
        floatingFilter: false,
        headerComponentParams: {
          headerChecked: this.headerCheckboxChecked,
        },
        headerComponentFramework: HeaderCheckboxGroupComponent,
        cellRendererFramework: RowCheckboxPartsComponent,
        hide: !this.accessEdit
      },
      {
        headerName: 'Part No',
        field: 'item_id',
        width: 170,
        floatingFilter: true,
        sortable: true,
      },
      {
        headerName: 'Kanban',
        field: 'kanban',
        sortable: true,
        width: 180,
        floatingFilter: true,
      },
    
      {
        headerName: 'Address',
        field: 'address',
        width: 200,
        floatingFilter: true,
        sortable: true,
      },
    ];

    this.columnDefs1 = [...this.columnDefsMaster1];
    //second grid
    this.columnDefsMaster = [
      
      {
        headerName: 'Action',
        cellRendererFramework: PartsActionsComponent,
        // floatingFilterComponentFramework: GridRefreshComponent,
        field: 'actions',
        width: 80,
        sortable: false,
        floatingFilter: false,
        hide: !this.accessEdit
      },
      {
        headerName: 'Groups',
        field: 'group_name',
        width: 150,
        floatingFilter: true,
        sortable: true,
        tooltipField: 'group_name',
        headerTooltip: 'Groups',
        // cellRenderer: "agGroupCellRenderer",
        cellRenderer: (params) => {
          return `<a href="javascript:void(0)" style="text-decoration: underline; color: #2688DA;">${params.value}</a>`;
        },
      },
      {
        headerName: 'Count',
        field: 'cycle_count_freq',
        sortable: true,
        width: 100,
        floatingFilter: true,
        tooltipField: 'cycle_count_freq',
        headerTooltip: 'Count',
        floatingFilterComponentParams: { suppressFilterButton: false },
        filterParams: {
          numberParser: (text) => {
            return text === null ? null : parseFloat(text.replace(',', '.'));
          },
        },
      },
    
      {
        headerName: 'User',
        field: 'updated_userid',
        width: 130,
        floatingFilter: true,
        sortable: true,
        headerClass: 'ag-theme-custom-text-right',
        tooltipField: 'updated_userid',
      },
      {
        headerName: 'Updated DT',
        field: 'updated_date_time',
        width: 180,
        floatingFilter: true,
        sortable: true,
        headerClass: 'ag-theme-custom-text-right',
        headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))',
        tooltipField: 'updated_datetime',
      },

    ];

    this.columnDefs = [...this.columnDefsMaster];
    
    //third grid
    this.columnDefsMaster2 = [
      
      {
        headerName: 'Action',
        field: 'actions',
        width: 80,
        sortable: false,
        floatingFilter: false,
        headerComponentParams: {
          headerChecked: this.headerCheckboxChecked1,
        },
        headerComponentFramework: HeaderCheckboxGroupComponent,
        cellRendererFramework: RowCheckboxPartsComponent,
        hide: !this.accessEdit
      },
      {
        headerName: 'Part No',
        field: 'part_no',
        width: 270,
        floatingFilter: true,
        tooltipField: 'part_no',
        sortable: true,
      },
      {
        headerName: 'Kanban',
        field: 'kanban',
        sortable: true,
        width: 280,
        floatingFilter: true,
      },
    ];

    this.columnDefs2 = [...this.columnDefsMaster2];
    // Grid 3 configuration (ensure multi-selection is enabled)
    this.gridOptions3 = {
      rowSelection: 'multiple',  // Multi-selection enabled
      suppressRowClickSelection: true, // Optionally, prevent row selection when clicking on row (if needed)
      // Add other configurations as necessary
    };
    this.setPageSizeToAll(this.defaultPageSize);
    
    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions2 = this.gridDataService.getGridOptions();
    this.gridOptions3 = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) { 
      this.gridApi = params.api;
    };
    
    // this.gridOptions2.onGridReady = (params) => {
    //   this.gridApi2 = params.api;
    // };
    
    // this.gridOptions3.onGridReady = (params) => {
    //   this.gridApi3 = params.api;
    // };
    
    this.adjustSubscription$ = this.stateService
      .getNamc()
      .subscribe((observable) => {
        this.initializeData();
      });
    // this?.onSearch(0);

  }

  initializeData() {
    this.spinner.show();
    this.rowData = [];
    this.spinner.show();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }

    this.loadDrop();
    this.onResetDropDown();   
    // this?.onSearch(0);

    // this.lookupService.getEasternDate().subscribe({
    //   error: this.errorCallback,
    //   next: (res) => {
    //     this.easternDate = res.body.data;
    //   },
    // });
  }
  checkIfAnySelected() {

    if (
      this.selectedDock.length != 0
    ) {
      return true;
    }
    return false;
  }

  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);
      return;
    }
  }

  onSearch(offset: number) {
    if (this.osPartsGrid?.gridOptions?.api) {
      const api = this.osPartsGrid.gridOptions.api;
  
      this.removeMessage();
  
      // ✅ Reset Grid 2
      // if (this.grid2?.api) {
      //   const grid2Api = this.grid2.api;
      //   if (typeof grid2Api.setRowData === 'function') {
      //     grid2Api.setRowData([]);
      //   }
      //   if (typeof grid2Api.deselectAll === 'function') {
      //     grid2Api.deselectAll();
      //   }
      //   if (typeof grid2Api.setFilterModel === 'function') {
      //     grid2Api.setFilterModel(null);
      //   }
      //   if (typeof grid2Api.setSortModel === 'function') {
      //     grid2Api.setSortModel(null);
      //   }
      //   if (typeof grid2Api.paginationGoToFirstPage === 'function') {
      //     grid2Api.paginationGoToFirstPage();
      //   }
      // }
    
  
      if (offset === 0) {
        this.setPageSizeToAll(this.defaultPageSize);
        this.offset = 0;
        this.spinner.show();
      }
  
      if (!this.checkIfAnySelected()) {
        this.rowData = [];
        this.warningMessage = warningMessage.selectDock;
        window.scroll(0, 0);
        this.spinner.hide();
        return false;
      }
  
      let selectedDock;
      if (this.selectedDock && this.selectedDock.dock) {
        selectedDock = [this.selectedDock.dock];
      }
  
      if (this.isManualSearch && !this.selectedGroupId?.group_name && !this.selectedGroupId) {
        this.warningMessage = 'Please select a part group first.';
        window.scroll(0, 0);
        this.spinner.hide();
        if (this.grid2?.api) {
          this.grid2.api.deselectAll();
          this.paginationPageSize = this.rowData.length;
          this.grid2.api.paginationSetPageSize(this.paginationPageSize);
        }
        return;
      }
  
      const data = {
        offset: offset,
        limit: 12000,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        dock: selectedDock,
        address: this.selectedGetAddress.address || '',
      };
  
      const currentPage = api.paginationGetCurrentPage();
      const currentPageSize = api.paginationGetPageSize();
      const currentSortModel = api.getSortModel ? api.getSortModel() : [];
      const currentFilterModel = api.getFilterModel ? api.getFilterModel() : {};
  
      this.OspService.getPartsCountGroup(data).subscribe({
        error: (err) => {
          this.errorCallback(err);
          // this.isManualSearch = false; // ✅ Reset manual flag on error
        },
        next: (res) => {
          if (res.body && res.body.data) {
            this.rowData = []; // reset before pushing
            this.rowData.push(...res.body.data);
            this.grid2.api.setRowData(this.rowData);
  
            if (this.grid2?.api) {
              const grid2Api = this.grid2.api;
              const grid2CurrentPage = grid2Api.paginationGetCurrentPage();
              const grid2CurrentPageSize = grid2Api.paginationGetPageSize();
              const grid2CurrentSortModel = grid2Api.getSortModel ? grid2Api.getSortModel() : [];
              const grid2CurrentFilterModel = grid2Api.getFilterModel ? grid2Api.getFilterModel() : {};
  
              grid2Api.setRowData(this.rowData);
              grid2Api.paginationGoToPage(grid2CurrentPage);
              grid2Api.paginationSetPageSize(grid2CurrentPageSize);
              if (grid2CurrentSortModel.length) {
                grid2Api.setSortModel(grid2CurrentSortModel);
              }
              if (Object.keys(grid2CurrentFilterModel).length > 0) {
                grid2Api.setFilterModel(grid2CurrentFilterModel);
              }
            }
  
            api.paginationGoToPage(currentPage);
            api.paginationSetPageSize(currentPageSize);
            if (currentSortModel.length) {
              api.setSortModel(currentSortModel);
            }
            if (Object.keys(currentFilterModel).length > 0) {
              api.setFilterModel(currentFilterModel);
            }
  
            this.dataCount = parseInt(res.body.data.rowCount);
            const records = this.dataCount - (this.offset + 1) * 12000;
            if (records >= 1) {
              this.offset++;
              this.onSearch(this.offset * 12000);
              this.paginationPageSize = this.rowData.length;
              setTimeout(() => {
                if (this.grid2?.api) {
                  this.grid2.api.paginationSetPageSize(this.paginationPageSize);
                  this.grid2.api.setRowData(this.rowData);
                }
              },100);
            } else {
              this.spinner.hide();
              if (this.selectedGroupId) {
                const rowIndex = this.rowData.findIndex(row => row.id === this.selectedGroupId);
                const rowNode = this.grid2.api.getDisplayedRowAtIndex(rowIndex);
                if (rowNode) {
                  rowNode.setSelected(true);
                  this.grid2.gridOptions.api.ensureIndexVisible(rowIndex, 'middle');
                }
                this.onloadGrid(this.selectedGroupId);
                this.onloadGridData(this.selectedGroupId);
              }
            }
          } else {
            this.rowData = [];
            // this.rowData = [];
            this.paginationPageSize = this.rowData.length;
            setTimeout(() => {
              if (this.grid2?.api) {
                this.grid2.api.paginationSetPageSize(this.paginationPageSize);
                this.grid2?.api?.setRowData([]);
              }
            },100);
            this.spinner.hide();
          }
  
          this.setPageSizeToAll();
          this.isManualSearch = false; // ✅ Reset manual flag after success
        },
      });
      return true;
    }
  }
      
  triggerManualSearch() {
    this.isManualSearch = true;
    this.onSearch(0);
  }
  
  loadDrop() {
    this.spinner.show();
  
    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
    };
  
    // Get selected dock from query param
    //let incomingDockValue = null;
    // this.route.queryParams.subscribe(params => {
    //   const dockParam = params['selectedDock'];
    //   if (dockParam) {
    //     try {
    //       const parsed = JSON.parse(dockParam);
    //       incomingDockValue = parsed[0]; // Use first value if it's an array
    //     } catch (e) {
    //       console.error('Invalid selectedDock param:', e);
    //     }
    //   }
    // });
  
    const lookupSubscriptions = [
      this.lookupService.getKanban(),
      this.lookupService.getPartNumber(),
      this.lookupService.getDock(),
      this.lookupService.getqpcforpart(),
      // this.partsCountService.getAddress(data),
    ];
  
    forkJoin(lookupSubscriptions).subscribe({
      next: ([kanbanRes, partNoRes, dockRes, qpcRes, addressRes]) => {
        // Clear existing lists
        this.kanbanList = [];
        this.partNoList = [];
        this.partNoListAdd = [];
        this.dockList = [];
        this.dockListTo =[];
        this.dockListCopy =[];
        this.dockListForpopup = [];
        this.specialistList = [];
        this.qpcforParts = [];
        this.partNumberList = [];
        this.kanbanNumberList = [];
        this.getAddressList = [];
  
        // Populate dropdowns
        this.kanbanList.push(...kanbanRes.body.data);
        this.kanbanNumberList.push(...kanbanRes.body.data);
  
        this.partNoList.push(...partNoRes.body.data);
        this.partNoListAdd.push(...partNoRes.body.data);
        this.partNumberList.push(...partNoRes.body.data);
  
        this.dockList.push(...dockRes.body.data);
        this.dockListForpopup.push(...dockRes.body.data);
        console.log('Dock list:', this.dockList);
  
        // this.qpcforParts.push(...qpcRes.body.data);
  
        // if (!addressRes?.error && addressRes?.body) {
        //   this.getAddressList.push(...addressRes.body);
        // } else {
        //   this.warningMessage = 'Try after some time! Error in ADDRESS';
        // }
        if (!qpcRes?.error && qpcRes?.body?.data) {
          if (qpcRes.body.data) {
            this.rowdata = qpcRes.body.data;

            // Get unique docks
            const docks = new Set();
            this.dockList = [];
            this.dockListTo = [];

            this.rowdata.forEach((item) => {
              if (!docks.has(item.dock)) {
                docks.add(item.dock);
                this.dockList.push({ dock: item.dock });
                this.dockList = this.dockList.sort((a, b) => a.dock.localeCompare(b.dock));
                // this.kanbanList.push({kanban:item.kanban});
                // this.specialistList.push({employee:item.employee});
              }
            });
            // this.dockListCopy = this.dockList;
            // const dockSet = new Set();
            // this.dockListTo = this.rowdata;
          }}
        // ✅ Set default selected dock (once dockList is loaded)
        // if (incomingDockValue) {
        //   const matchedDock = this.dockList.find(d => d.dock === incomingDockValue);
        //   if (matchedDock) {
        //     this.selectedDock = matchedDock;
        //     console.log('Default dock selected:', this.selectedDock);
            
        //     // Ensure the grid refreshes after dock is selected
        //     this.onSearch(0);  // Trigger the search after setting the selectedDock
        //   }
        // } 
        // else {
        //   // If no dock is selected, trigger search to load grid
        //   this.onSearch(0);
        // }
        if(this.assignDefaultDock()){
          this.dockChange();
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.errorCallback(err);
        this.spinner.hide();
      }
    });
  }
  
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  errorCallback = (error) => {
    logErrors(error);
    this.spinner.hide();

    this.warningMessage = 'Something went wrong! Please contact support team.';
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

  onResetDropDown() {
    this.removeMessage();
    // this.selectedKanban = [];
    // this.selectedPartNo = [];
    // this.selectedDock = [];
    this.selectedGetAddress = [];
    // this.selectedSpecialist = [];
    // this.selectedpolicyName = [];
    // this.effectiveFrom = '';
    // this.effectiveTo = '';
    
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.headerCheckboxChecked1 = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    this.setPageSizeToAll(this.defaultPageSize);

    // this.rowData = [];
    this.offset = 0;
  }

  userCheckChanged(checked: boolean, rowIndex: number, isGrid3: boolean = false) {
    const gridRef = isGrid3 ? this.grid3 : this.grid1;
    const headerCheckboxProp = isGrid3 ? 'headerCheckboxChecked1' : 'headerCheckboxChecked';
  
    const rowNode = gridRef?.api?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;
  
    rowNode.setSelected(checked);
    rowNode.data.rowCheckBox = checked;
    rowNode.setData(rowNode.data);
  
    // Check if all checkboxes are selected
    let allChecked = true;
    gridRef.api.forEachNode((node) => {
      if (!node.data.rowCheckBox) {
        allChecked = false;
      }
    });
  
    this[headerCheckboxProp] = allChecked;
    gridRef.api.refreshHeader();
  }
  
  headerCheckChanged(event: any) {
    this.headerCheckboxChecked = event.checked;
  
    if (this.grid1?.api) {
      this.grid1.api.forEachNode((rowNode) => {
        rowNode.data.rowCheckBox = event.checked;
        rowNode.setData(rowNode.data);
      });
    }
  }
  headerCheckChangedGrid1(event: any) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
  
    if (this.grid1?.api) {
      this.grid1.api.forEachNode((rowNode) => {
        rowNode.data.rowCheckBox = headerChecked;
        rowNode.setSelected(headerChecked);
        rowNode.setData(rowNode.data);
      });
      this.grid1.api.refreshHeader();
    }
  }
  
  headerCheckChangedGrid3(event: any) {
    this.headerCheckboxChecked1 = event.checked;
    const headerChecked = event.checked;
  
    if (this.grid3?.api) {
      this.grid3.api.forEachNode((rowNode) => {
        rowNode.data.rowCheckBox = headerChecked;
        rowNode.setSelected(headerChecked);
        rowNode.setData(rowNode.data);
      });
      this.grid3.api.refreshHeader();
    }
  }

  toggleHeaderCheckbox(isGrid3: boolean = false) {
    const gridRef = isGrid3 ? this.grid3 : this.grid1;
    const headerCheckboxProp = isGrid3 ? 'headerCheckboxChecked1' : 'headerCheckboxChecked';
  
    let allChecked = true;
    gridRef.api.forEachNode((node) => {
      if (!node.data.rowCheckBox) {
        allChecked = false;
      }
    });
  
    this[headerCheckboxProp] = allChecked;
    gridRef.api.refreshHeader();
  }

  dockChange() {
    this.selectedGroupId = null;
    this.isManualSearch = false;
    this.onSearch(0); 
    this.defaultService.setDockCode(JSON.stringify([{dock : this.selectedDock.dock}]));
    this.addressData();
  }
  addressData(){
    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
      dock: this.selectedDock?.dock,
    };
    this.spinner.show();
    this.partsCountService.getAddress(data).subscribe(
      {
        next: (res) => {
          
          if (res.body === "No Content"){
            //NCR
          }else{
            this.getAddressList = res.body;
            if (this.getAddressList.length > 0){
              this.getAddressList = res.body;           
            }
          }
          this.spinner.hide();
        },
        error: (error) => this.errorCallback(error),
      }
    )
  }
  assignDefaultDock(){
    try {
      if (this.dockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.find(item => validDocks.has(item.dock));
          if (this.selectedDock){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock',error);
      return false;
    }
  }

  getAddressChange(): void {
    if (this.selectedGetAddress.length >= 1) {
      this.selectedGetAddress = {
        address: [this.selectedGetAddress.address],
      };
    }
  }
  getModifiedRowData(): any {
    return this.rowData.filter((row) => row.rowCheckBox);
  }

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }

  userDeleteChanged(rowIndex) {
    const rowNode =
      this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    this.openDeleteDialog(rowNode.data);
  }

  userEdit(rowIndex) {
    const rowNode =
      this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    this.openEditDialog(rowNode.data);
  }

  // delete button popup
  openDeleteDialog(dataTODelete) {
    var data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
      id: dataTODelete?.id
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.data = {
      mode: 'Parts Group',
    };
    dialogConfig.width = '410px';
    const dialogRef = this.dialog.open(DeleteBreaksComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      this.removeMessage();
      if (res === 'cancel') {
        return;
      }
      if (res === 'save') {
        this.spinner.show();
        this.OspService.deleteGroups(data).subscribe({
          error: this.errorCallback,
          next: (data) => {
            if (data.body.table1DeletedCount >= 1 || data.body.table2DeletedCount >= 1) {
              this.onSearch(0);
              this.successMessage = successMessage.deleteRecord;
              window.scroll(0, 0);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
              this.rowData = [];
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
              this.spinner.hide();
            }
            this.spinner.hide();

          },
        });
      }
    });
  }
 
  //edit button popup
  openEditDialog(data) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '420px';
    dialogConfig.height = '320px';
    dialogConfig.data = {
      qpcPartsList: this.qpcforParts,
      partNumber: this.partNumberList,
      kanbanNumber: this.kanbanNumberList,
      data,
      mode: 'edit',
      groupName:data.group_name,
      cycleCount:data.cycle_count_freq,
      dock: data.dock,
      id:data.id,
    };

    const dialogRef = this.dialog.open(EditPartsGroupDialogComponent, dialogConfig);
    const editGetResponse =
      dialogRef.componentInstance.editPartsGroupEventEmitter.subscribe((res) => {
        var data1 = {
          offset: 0,
          limit: 12000,
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          updated_userid: this.userName,
          dock: data.dock,
          group_name: res.groupName.trim(),
          cycle_count_freq: Number(res.countCycle.toString().trim()),
          id: data.id
        };
        console.log(data1,'data1')
        this.OspService.editGroup(
          data1
        ).subscribe({
          error: this.errorCallback,
          next: (response) => {
            this.spinner.hide();
            const responseBody = response.body;
          
            if (Array.isArray(responseBody)) {
              if (responseBody.length > 0) {
                // this.rowData = responseBody;
                this.onSearch(0)
                // this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
                // this.successMessage = successMessage.groupUpdated;
                this.successMessage = `Parts Group "${responseBody[0].group_name}" updated successfully`;

              } else {
                this.successMessage =  'No changes were made.';
              }
            } else if (typeof responseBody === 'string' && responseBody === 'Group Name already exists') {
              this.warningMessage = 'Group Name already exists. Please choose a different name.';
            } else {
              this.warningMessage = `${warningMessage.reportsNotUpdated} ${this.itContact}.`;
            }
          
            window.scroll(0, 0);
            this.setPageSizeToAll();
            window.scroll(0, 0);
          }
          
        });
      });
    dialogRef.afterClosed().subscribe((res) => {
      editGetResponse.unsubscribe();
    });
  }
  openAddGroupDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '420px';
    dialogConfig.height = '320px';
    dialogConfig.data = {
      // dock: this.dockList,
      mode: 'add',
      dock:this.selectedDock
    };
    console.log(this.selectedDock)
    const dialogRef = this.dialog.open(AddPartsGroupDialogComponent, dialogConfig);
    const editGetResponse =
      dialogRef.componentInstance.addPartsGroupEventEmitter.subscribe((res) => {
        var data = {
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          dock: res.dock,
          policy_name: res.policyName,
          description: res.description,
          group_name:res.groupName, 
          cycle_count_freq:res.countCycle,
          plant: '01',
        }
        this.spinner.show();
        this.OspService.addGroups(
          data
        ).subscribe({
          error: this.errorCallback,
          next: (response) => {
            this.spinner.hide();
            const responseBody = response.body.updatedRows;
            const responseBody1 = response.body;
            if (Array.isArray(responseBody)) {
              if (responseBody.length > 0) {
                // this.rowData = responseBody;
                this.onSearch(0)
                // this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
                this.successMessage = `Parts Group "${responseBody[0].group_name}" added successfully`;
              } else {
                this.successMessage =  'No changes were made.';
              }
            } else if (responseBody1.length > 0) {
              this.warningMessage = responseBody1;
            } else {
              this.warningMessage = `${warningMessage.reportsNotUpdated} ${this.itContact}.`;
            }

            window.scroll(0, 0);
            this.setPageSizeToAll();
            window.scroll(0, 0);
          },
        });
      });
    dialogRef.afterClosed().subscribe((res) => {
      editGetResponse.unsubscribe();
    });
  }
  onCellClicked(event: any): void {
    if (event.colDef.field === 'group_name' && event.data?.id) {
      const groupId = event.data.id;
      this.selectedGroupId = groupId; // store it globally
      this.onloadGrid(groupId);
      this.onloadGridData(groupId);
    }
  }
  // third grid data
  onloadGrid(groupId: string) {
    this.removeMessage();
  
    const data = {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: this.selectedDock.dock,
      id: groupId
    };
  
    this.spinner.show();
  
    this.OspService.getEditGroupInsideGrid(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        this.spinner.hide();
  
        const updatedRows = res.body?.data || [];
  
        if (updatedRows.length > 0) {
          this.displayRowData1 = updatedRows; // ✅ this is the correct variable bound to Grid 3
  
          // Set the data directly to Grid 3
          this.paginationPageSize2 = this.displayRowData1.length;


          setTimeout(() => {
            if (this.grid3?.api) {
              this.grid3.api?.paginationSetPageSize(this.paginationPageSize2);
              this.grid3.api.setRowData(this.displayRowData1);
            }
          });
        } else {
          this.displayRowData1 = [];          
          this.paginationPageSize2 = this.displayRowData1.length;
          setTimeout(() => {
            if (this.grid3?.api) {
              this.grid3.api.paginationSetPageSize(this.paginationPageSize2);
              this.grid3?.api?.setRowData([]);
            }
          },100);
        }
      },
    });
  }
  // first grid data
  onloadGridData(groupId: string) {
    this.removeMessage();
  
    const data = {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: this.selectedDock.dock,
      group_id: groupId,
      address:this.selectedGetAddress.address || '',
    };
  
    this.spinner.show();
  
    this.OspService.leftGridPartsNotInGroups(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        this.spinner.hide();
  
        const updatedRows = res.body?.data || [];
  
        if (updatedRows.length > 0) {
          // Initialize checkboxes
          this.displayRowData = updatedRows.map(row => ({
            ...row,
            rowCheckBox: false // add this field
          }));
        
          this.paginationPageSize1 = this.displayRowData.length;
          setTimeout(() => {
            if (this.grid1?.api) {
              this.grid1.api.paginationSetPageSize(this.paginationPageSize1);
              this.grid1.api.setRowData(this.displayRowData);
            }
          });
        } else {
          this.displayRowData = [];
          this.paginationPageSize1 = this.displayRowData.length;
          setTimeout(() => {
            if (this.grid1?.api) {
              this.grid1.api.paginationSetPageSize(this.paginationPageSize1);
              this.grid1?.api?.setRowData([]);
            }
          },100);
        }
      },
    });
  }
  
  rightArrowParts(groupId: string) {
    if (!groupId) {
      this.warningMessage = 'Please select a group before transferring parts.';
      window.scroll(0, 0);
      return;
    }
  
    this.removeMessage();
  
    // Get selected rows from Grid 1
    const selectedParts: any[] = [];
    if (this.grid1?.api) {
      this.grid1.api.forEachNode((rowNode) => {
        if (rowNode.data?.rowCheckBox === true) {
          selectedParts.push({
            part_no: rowNode.data.item_id,
            kanban: rowNode.data.kanban,
          });
        }
      });
    }
  
    if (selectedParts.length === 0) {
      this.warningMessage = 'Please select at least one part to move.';
      window.scroll(0, 0);
      return;
    }
  
    const data = {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: this.selectedDock.dock,
      group_id: groupId,
      updated_userid: this.userName,
      created_userid: this.userName,
      partsDetails: selectedParts, // ✅ dynamic
    };
  
    this.spinner.show();
  
    this.OspService.rightArrowButton(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        this.spinner.hide();
  
        const updatedRows = res.body?.data || [];
  
        if (updatedRows.length > 0) {
          this.displayRowData1 = updatedRows;
          this.paginationPageSize2 = this.displayRowData1.length;
  
          setTimeout(() => {
            if (this.grid3?.api) {
              this.grid3.api.paginationSetPageSize(this.paginationPageSize2);
              this.grid3.api.setRowData(this.displayRowData1);
            }
          });
        } else {
          this.displayRowData1 = [];
          this.grid3?.api?.setRowData([]);
        }
        this.onloadGridData(groupId);
        this.onloadGrid(groupId);
        this.successMessage = successMessage.deleteRecord;
        this.headerCheckboxChecked = false;
        setTimeout(() => {
          this.grid1?.api?.refreshHeader();          
        });
      },
    });
  }

  //delete Api
  leftArrowParts(groupId: string): void {
    // Step 1: Clear any existing messages
    this.removeMessage();

    // Step 2: Ensure a part group is selected
    if (!groupId) {
      this.warningMessage = 'Please select a part group first.';
      window.scrollTo(0, 0);
      return;
    }

    // Step 3: Ensure grid3 is accessible and fetch selected rows
    const modifiedRowData = this.displayRowData1.filter((row) => row.rowCheckBox);

    const selectedIds: string[] = modifiedRowData
      .filter(r => r.rowCheckBox)
      .map(node => node.id);

    //return;
    if (selectedIds.length === 0) {
      this.warningMessage = 'Please select at least one part to move.';
      window.scrollTo(0, 0);
      return;
    }

    console.log('Selected Row IDs:', selectedIds);

    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.width = '460px';
    // dialogConfig.height = '200px';
    // dialogConfig.data = {
    //   mode: 'Delete Parts',
    // };

    // const dialogRef = this.dialog.open(DeleteBreaksComponent, dialogConfig);

    // dialogRef.afterClosed().subscribe((res) => {
      // if (res === 'cancel') return;

      // if (res === 'save') {
        this.spinner.show();

        const data1 = {
          offset: 0,
          limit: 1200,
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          id: selectedIds,              // multiple IDs
          // group_id: groupId,            //  also sending groupId
        };

        this.OspService.deleteParts(data1).subscribe({
          error: this.errorCallback,
          next: (data) => {
            if (data.body.tableDeletedCount >= 0) {
              this.onloadGrid(groupId); // Refresh grid based on group
              this.onloadGridData(groupId);
              this.successMessage = successMessage.deleteRecord;
              window.scroll(0, 0);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail} ${this.itContact}.`;
              this.rowData = [];
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            }
            this.spinner.hide();
            // **Reset header checkbox after the data update**
            this.headerCheckboxChecked = false; // Reset header checkbox for Grid 1
            this.headerCheckboxChecked1 = false; // Reset header checkbox for Grid 3

            // Refresh headers for both Grid 1 and Grid 3
            setTimeout(() => {
              if (this.grid1?.api) {
                this.grid1.api.refreshHeader();
              }
              if (this.grid3?.api) {
                this.grid3.api.refreshHeader();
              }
            });
          },
        });
      // }
    };
  // }
  
  goBack() {
    localStorage.setItem('isClearMsg', 'true');
    // this.location.back();
    // this.router.navigate(['./inventory/parts-count']);
    this.router.navigate(['./inventory/parts-count'],
      //{queryParams: {selectedDock:JSON.stringify([this.selectedDock.dock])}}
    );

  }

}
